import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import dayjs from 'dayjs'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { KeyRoundIcon, PencilIcon, Trash2Icon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { ApiClient, apiClients } from 'service/api'

export default function CredenciaisApi() {
    const { data, isLoading } = apiClients.useFetch()

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={['Integrações', 'Credenciais de API']}
                />
                <ContentGuide.DataGrid
                    onAdd
                    columns={[
                        {
                            field: 'nome',
                            headerName: 'Nome',
                            flex: 1,
                            minWidth: 150,
                        },
                        {
                            field: 'clientId',
                            headerName: 'Client ID',
                            flex: 1,
                            minWidth: 180,
                        },
                        {
                            field: 'scopes',
                            headerName: 'Escopos',
                            flex: 1.5,
                            minWidth: 220,
                            renderCell: ({ value }) =>
                                Array.isArray(value) && value.length > 0
                                    ? value.join(', ')
                                    : '',
                        },
                        {
                            field: 'rateLimitRpm',
                            headerName: 'RPM',
                            width: 110,
                            align: 'center',
                            valueFormatter: ({ value }) =>
                                `${value || 60} req/min`,
                        },
                        {
                            field: 'ativo',
                            headerName: 'Status',
                            width: 100,
                            align: 'center',
                            renderCell: ({ value }) =>
                                value === 'S' ? (
                                    <span className="text-success font-medium">
                                        Ativo
                                    </span>
                                ) : (
                                    <span className="text-error font-medium">
                                        Inativo
                                    </span>
                                ),
                        },
                        {
                            field: 'ultimoAcessoEm',
                            headerName: 'Último Acesso',
                            width: 160,
                            align: 'center',
                            renderCell: ({ value }) =>
                                value
                                    ? dayjs(value).format('DD/MM/YYYY HH:mm')
                                    : '',
                        },
                        {
                            ...optionsColumn,
                            field: '__regenerar',
                            renderCell: ({ id }) =>
                                hasPermission(
                                    ['update', 'CredenciaisDeAPI'],
                                    () => (
                                        <IconButton
                                            title="Regenerar segredo"
                                            href={`${id}/regenerar`}
                                        >
                                            <KeyRoundIcon />
                                        </IconButton>
                                    ),
                                ),
                        },
                        {
                            ...optionsColumn,
                            field: '__editar',
                            renderCell: ({ id }) =>
                                hasPermission(
                                    ['update', 'CredenciaisDeAPI'],
                                    () => (
                                        <IconButton
                                            title="Editar"
                                            href={`${id}/editar`}
                                        >
                                            <PencilIcon />
                                        </IconButton>
                                    ),
                                ),
                        },
                        {
                            ...optionsColumn,
                            field: '__excluir',
                            renderCell: ({ id }) =>
                                hasPermission(
                                    ['delete', 'CredenciaisDeAPI'],
                                    () => (
                                        <IconButton
                                            title="Excluir"
                                            href={`${id}/excluir`}
                                        >
                                            <Trash2Icon className="text-error" />
                                        </IconButton>
                                    ),
                                ),
                        },
                    ]}
                    rows={data}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-credenciais-api',
                        },
                        showQuickFilter: true,
                    }}
                    loading={isLoading}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useCredenciaisApiOutletContext() {
    return useOutletContext<{
        data?: ApiClient[]
    }>()
}
